export function getActiveLiveContent() {
    return window.__UpshowState && window.__UpshowState.activeLiveContent;
}
